import { UIComponents } from "../ui";

/**
 * Renders a single information field with label and value
 */
const LabeledValue = ({
  label,
  value,
}: {
  label: string;
  value: string;
}): React.ReactElement => {
  return (
    <div className="space-y-1.5">
      <UIComponents.label className="text-sm font-medium text-muted-foreground">
        <b>{label}</b>
      </UIComponents.label>
      <p className="text-sm text-foreground break-words">{value || "-"}</p>
    </div>
  );
};

export default LabeledValue;
